import { render, staticRenderFns } from "./ConfigTask.vue?vue&type=template&id=450bf330&scoped=true&"
import script from "./ConfigTask.vue?vue&type=script&lang=js&"
export * from "./ConfigTask.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTask.vue?vue&type=style&index=0&id=450bf330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bf330",
  null
  
)

export default component.exports